import { useState, useEffect } from "react";
import Order from "../../../actions/order";
import Notify from "../../../components/customHelpers/Notify";

export const useOrderManagement = () => {
  const { NotifyMessage } = Notify();
  const { viewOrderProducts } = Order();
  const [orders, setOrders] = useState([]);

  const getAllOrders = () => {
    viewOrderProducts().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setOrders(data.orders);
      }
    });
  };

  const filterOrdersByProductId = (productId) => {
    return orders
      .filter((order) =>
        order.orderProducts.some((product) => product.sku === productId)
      )
      .map((order) => {
        const totalQuantity = order.orderProducts
          .filter((product) => product.sku === productId)
          .reduce(
            (total, product) => total + parseInt(product.quantity, 10),
            0
          );

        return {
          status: order.status,
          totalQuantity: totalQuantity,
        };
      });
  };

  const groupByStatusAndSumQuantities = (filteredResults) => {
    const groupedResults = {};

    const possibleStatuses = ["Ordered", "Pending"];
    possibleStatuses.forEach((status) => {
      groupedResults[status] = 0;
    });

    filteredResults.forEach((result) => {
      if (groupedResults[result.status] !== undefined) {
        groupedResults[result.status] += result.totalQuantity;
      }
    });

    return Object.keys(groupedResults).map((status) => ({
      status: status,
      totalQuantity: groupedResults[status],
    }));
  };

  const addPendingOrderLocally = (newItem) => {
    setOrders((prevOrders) => [
      ...prevOrders,
      {
        orderProducts: [
          {
            sku: newItem.sku,
            quantity: newItem.quantity,
            status: newItem.status || "Pending",
          },
        ],
        status: "Pending",
      },
    ]);
  };
  const removePendingOrderLocally = (sku, quantity) => {
    setOrders((prevOrders) => {
      let updatedOrders = [...prevOrders];
      for (let i = updatedOrders.length - 1; i >= 0; i--) {
        const order = updatedOrders[i];
        const productIndex = order.orderProducts.findIndex(
          (product) => product.sku === sku && product.status === "Pending"
        );
        if (productIndex !== -1) {
          const currentQuantity = order.orderProducts[productIndex].quantity;
          if (currentQuantity <= quantity) {
            updatedOrders.splice(i, 1);
          } else {
            order.orderProducts[productIndex].quantity -= quantity;
          }
          break;
        }
      }
      return updatedOrders;
    });
  };
  useEffect(() => {
    getAllOrders();
  }, []);

  return {
    orders,
    getAllOrders,
    filterOrdersByProductId,
    groupByStatusAndSumQuantities,
    addPendingOrderLocally,
    removePendingOrderLocally
  };
};